<div *ngIf="board.tilingFormats?.length > 0" class="tiling-margin">
  <span class="strong">Tiling borden: </span>
  <span class="preserve-line-break">{{ board.tilingFormats }}</span>
</div>

<!-- TODO this was copied from sign size edit, consider creating a component to use both here and in sign size edit:
    1) Create SignSizeRequirementAware interface, make SignConstructionRequirement and BoardConstructionMaterial implement this
    2) Create or change SignSizeRequirementAware array variable in SignSize and Board, make both implement interface that has that variable
    3) Use interface from Step 2 as input type for new component
-->
<div class="flex-col">
  <div class="flex-table">
    <div class="flex-header-row">
      <div class="flex-2">Item</div>
      <div class="flex-2">Lengte (cm)</div>
      <div class="flex-2">Beschrijving</div>
      <div class="flex-2">Aantal</div>
      <div *ngIf="!disabled" class="flex-1"></div>
    </div>
    <div
      class="flex-table-row"
      [ngClass]="disabled && i > 0 ? 'small-upper-space' : ''"
      *ngFor="
        let material of board.boardConstructionMaterials;
        index as i;
        trackBy: trackById
      "
    >
      <ng-container *ngIf="!disabled">
        <div class="flex-table-cell flex-2">
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              [(ngModel)]="material.signConstructionMaterialType"
              [compareWith]="compareConstructionMaterialType"
              (ngModelChange)="update.emit()"
            >
              <mat-option
                *ngFor="let option of constructionMaterialTypeChoices"
                [value]="option"
              >
                {{ option ? option.label : 'Andere' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-table-cell flex-2">
          <mat-form-field
            *ngIf="
              material.signConstructionMaterialType &&
              getConstructionMaterialTypeLengthChoices(
                material.signConstructionMaterialType
              )
            "
            appearance="outline"
          >
            <mat-select
              matInput
              placeholder="Kies lengte"
              [(ngModel)]="material.signConstructionMaterialLength"
              (ngModelChange)="update.emit()"
              required
            >
              <mat-option
                *ngFor="
                  let option of getConstructionMaterialTypeLengthChoices(
                    material.signConstructionMaterialType
                  )
                "
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-table-cell flex-2">
          <mat-form-field appearance="outline">
            <input
              matInput
              [(ngModel)]="material.description"
              (ngModelChange)="update.emit()"
            />
          </mat-form-field>
        </div>
        <div class="flex-table-cell flex-2">
          <mat-form-field appearance="outline">
            <input
              type="number"
              matInput
              [(ngModel)]="material.amount"
              (ngModelChange)="update.emit()"
              required
            />
          </mat-form-field>
        </div>
        <div
          class="flex-table-cell center flex-1 clickable"
          (click)="removeMaterial(i)"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </div>
      </ng-container>
      <ng-container *ngIf="disabled">
        <div class="flex-table-cell flex-2">
          {{ material.signConstructionMaterialType?.label }}
        </div>
        <div class="flex-table-cell flex-2">
          {{ material.signConstructionMaterialLength }}
        </div>
        <div class="flex-table-cell flex-2">
          {{ material.description }}
        </div>
        <div class="flex-table-cell flex-2">
          {{ material.amount }}
        </div>
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="!disabled"
    class="pull-left clickable"
    (click)="addConstructionMaterial()"
  >
    <mat-icon svgIcon="add"></mat-icon>
  </div>
</div>
